export default __webpack_public_path__ + "static/media/312-Series-Brass-Regulators.0519c88b.jpg";